<template>
    <div>
        <el-collapse :value="active" class="my-collapse-1" @change="changeCollapse">
            <el-collapse-item v-for="module1 in config" :name="module1.id">
                <template slot="title">
                    <div class="inline-block">
                        <span class="icon-caret el-icon-caret-right" :class="[(isFirst?active:activeNames).includes(module1.id)?'rotate':'']"></span>
                        <div class="inline-block ml6" @click.stop>
                            <el-checkbox :value="module1.checked" :disabled="module1.disabled" @change="changeModule(module1,$event)">
                                <span class="text-bold font14px">{{module1.display_name}}</span>
                            </el-checkbox>
                            <span class="ml20 font12px check-btn" @click="handleCheckAllChange(module1)">全选</span>
                        </div>
                    </div>
                </template>
                <CollapseCard
                    :config="module1.children||[]"
                    v-if="(module1.children||[]).some(item=>item.type=='0')"
                    @title-check-all="handleCheckAllChange"
                    @change-page="handleChangePage"
                    @show-modal="showCollapseModal"
                    @remove-parent-checked="removeParentsChecked"
                    @change-module="changeModule"
                    class="my-collapse-2"></CollapseCard>
                <div class="ml20 mr20" v-else>
                    <el-row :gutter="20" v-for="(page,index) in module1.children||[]" :key="page.name+index+'Tabs'" class="page-tab-item">
                        <el-col :span="5">
                            <div>
                                <el-checkbox v-model="page.checked" @change="handleChangePage(page,$event)" :disabled="page.disabled">{{page.display_name}}</el-checkbox>
                            </div>
                            <div>
                                <el-button type="text" v-if="page.fields.length>0" @click="showFieldsModal(page)">设置字段权限</el-button>
                                <el-button type="text" v-if="page.dimension.length>0" @click="showDimensionsModal(page)">设置维度权限</el-button>
                                <el-button type="text" v-if="page.special_func.length>0" @click="showConfigOptionalRoleModal(page)">配置可选角色</el-button>
                                <el-button type="text" v-if="page.statistical_period&&page.statistical_period.length>0" @click="showStatisticalPeriodModal(page)">统计周期权限</el-button>
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <template v-if="page.func&&page.func.length>0">
                                <el-checkbox v-for="item in page.func" class="fun-checkbox" :label="item.id" :value="item.checked" :disabled="item.disabled" :key="item.id" @change="handleChangeFuncItem(page,item,$event)">
                                    {{item.display_name}}
                                    <el-tooltip v-if="getItemTitle(item).length>0" class="item" effect="dark" :content="getItemTitle(item)" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-checkbox>
                            </template>
                            <div v-else>
                                <p class="text-color-gray">暂无数据</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    export default {
        name: "CollapseCard",
        props:{
            config:Array,
            active:{
                type:Array,
                required:false,
                default:() => ([]),
            },
        },
        data(){
            return {
                activeNames:[],
                isFirst:true,
            }
        },
        methods:{
            changeCollapse(val){
                this.activeNames = val;
                /* 为了修正小箭头的方向 */
                this.isFirst = false;
            },
            changeModule(module,val){
                console.log('changeModule',module,val);
                if(val){
                    this.$emit('change-module',module,val);
                }else{
                    // 取消选中
                    let pid = module.pid;
                    let pModule = this._findModuleById(this.config,pid);
                    console.log('pModule',pModule);
                    if(pid&&pModule&&pModule.checked==true){
                        module.checked = true;
                    }else{
                        this.$emit('change-page',module,val);
                    }
                }
            },
            handleCheckAllChange(module){
                console.log('handleCheckAllChange',module);
                this.$emit('title-check-all',module);
            },
            handleChangePage(page,val){
                console.log('handleChangePage',page,val);
                if(val){
                    this.$emit('change-page',page,val);
                }else{
                    // 取消选中
                    let pid = page.pid;
                    let pModule = this._findModuleById(this.config,pid);
                    console.log('pModule',pModule);
                    if(pid&&pModule&&pModule.checked==true){
                        page.checked = true;
                    }else{
                        this.$emit('change-page',page,val);
                    }
                }

            },
            showCollapseModal(page,type){
                console.log('showCollapseModal',page,type);
                this.$emit('show-modal',page,type);
            },
            showFieldsModal(page){
                console.log('showFieldsModal',page);
                let tagSubPage = [
                    'plat_management_page',
                    'bloc_management_page',
                    'company_management_page',
                    'account_management_page',
                    'plan_management_page',
                    'app_management_page',
                    'project_management_page',
                ];
                if(tagSubPage.includes(page.name)){
                    this.$emit('show-modal',page,'tag-fields');
                }else{
                    this.$emit('show-modal',page,'fields');
                }
            },
            showDimensionsModal(page){
                console.log('showDimensionsModal',page);
                this.$emit('show-modal',page,'dimensions');
            },
            showStatisticalPeriodModal(page){
                console.log('showStatisticalPeriodModal',page);
                this.$emit('show-modal',page,'period');
            },
            showConfigOptionalRoleModal(page){
                console.log('showConfigOptionalRoleModal',page);
                this.$emit('show-modal',page,'configOptionalRole');
            },
            handleChangeFunc(page,val){
                console.log('handleChangeFunc',page,val);
            },
            handleChangeFuncItem(page,item,val){
                console.log('handleChangeFuncItem',page,item,val);
                if(page.checked&&!val) return false;
                this.$set(item,'checked',val);
            },
            removeParentsChecked(page){
                console.log('removeParentsChecked',page)
                this.$emit('remove-parent-checked',page);
            },
            getItemTitle(item){
                let configStr = item.config||"{}";
                let config = JSON.parse(configStr)||{};
                return config.title||'';
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .check-btn{
        color: #808695;
        &:hover{
            color: #17233d;
        }
    }
    .fun-checkbox{
        min-width: 120px;
    }
    .icon-caret {
        transition: all .5s;
        font-size: 18px;
        margin-top: -2px;
    }
    .rotate {
        transform: rotate(90deg);
    }

    ::v-deep .input-err .el-input__inner{
        border-color: #F56C6C!important;
    }

    ::v-deep .el-collapse-item .el-collapse-item__header{
        background-color: #f2f2f2!important;
        border-bottom: 1px solid #aaa;
        height: 40px;
        line-height: 40px;
        padding-left: 14px;
    }

    ::v-deep .my-collapse-2 .el-collapse-item .el-collapse-item__header{
        padding-left: 30px;
    }

    .collapse-con-2{
        margin: 6px 50px;
    }
    .page-tab-item{
        padding: 10px 5px;
    }
</style>
